import { AxiosRequestConfig, Method } from 'axios';

import { apiClient } from './apiClient';

type AxiosFetcherParams = {
  body?: AxiosRequestConfig['data'];
  headers: Record<string, string>;
  method: Method;
  params?: AxiosRequestConfig['params'];
};

export const axiosFetcher = async <T = any>(
  path: string,
  { body, headers, method, params }: AxiosFetcherParams
): Promise<T> => {
  try {
    const response = await apiClient({
      data: body,
      headers,
      method,
      params,
      url: path,
    });

    return response.data as T;
  } catch (error: any) {
    if (error.response) {
      const data = error.response.data;
      throw new Error(
        typeof data === 'string'
          ? data
          : data?.message || data?.error || error.response.statusText
      );
    }

    throw error;
  }
};
